import React, { useContext } from "react";
import App, { LoginStatusContext } from "../App";
import fetcher, { paths } from "../lib/fetcher";
import { ClientTicketResult } from "../models/ClientTicketResult";
import { HTTPService } from "../lib/util";
import { Toast } from "@yy/tofu-ui-react";
import { stat } from "../lib/hooks/useHiidoPV";
// import useScrollPosition from "@react-hook/window-scroll";

const FloatTips = () => {
  const isLoggedIn = useContext(LoginStatusContext);

  async function handleClick() {
    // 数据上报
    stat.emit({ eventid: 20030927, act_type: "211" });

    // 未登录
    if (!isLoggedIn) {
      const { user } = await App.onHeaderReady();
      user.showYYLoginBox();
      return;
    }

    const { data, code, message } = (await fetcher.get(paths.yyClientTicket)) as ClientTicketResult;
    if (code === HTTPService.Ok) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = data;
      document.body.appendChild(iframe);
      Toast.info({
        text: "已成功启动YY客服对话框，请点击允许确认本次对话(请提前登录PCYY客户端)",
        duration: 5000,
      });
      setTimeout(() => {
        if (iframe) {
          document.getElementsByTagName("body")[0].removeChild(iframe);
        }
      }, 10000);
    } else {
      Toast.info({ text: message || "抱歉暂时无法联系客服，请稍后再试。" });
    }
  }
  return (
    <div className="float-tips" onClick={handleClick}>
      <i></i>
      <span>咨询官方</span>
    </div>
  );
};

export default FloatTips;
